import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { SnackbarService } from '../../../../services/snackbar/snackbar.service';
import { formatarCEP } from '../../../../shared/formatter';

@Component({
  selector: 'app-empresa-listar-estabelecimentos',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatSnackBarModule,
  ],
  templateUrl: './empresa-listar-estabelecimentos.html',
  styleUrls: ['./empresa-listar-estabelecimentos.scss'],
})
export class CadastrarEmpresaEstabelecimentos implements OnInit {
  @Input() dadosCompartilhados: any;

  filtroNome = '';
  estabelecimentos: any[] = [];
  estabelecimentosExibidos: any[] = [];
  carregando = false;

  constructor(private snackbarService: SnackbarService) {}

  async ngOnInit(): Promise<void> {
    await this.carregarEstabelecimentos();
    this.dadosCompartilhados.modoEdicaoEstabelecimento = false;
    this.dadosCompartilhados.estabelecimentoParaEditar = null;

    if (this.dadosCompartilhados) {
      this.dadosCompartilhados.onRecarregarEstabelecimentos = () =>
        this.recarregarEstabelecimentos();
    }
  }

  async carregarEstabelecimentos(): Promise<void> {
    if (!this.dadosCompartilhados?.empresaSalva?.id) {
      this.snackbarService.error('ID da empresa não disponível');
      return;
    }

    this.carregando = true;
    try {
      const res = await this.dadosCompartilhados.axiosClient.get(
        `/estabelecimento/empresa/${this.dadosCompartilhados.empresaSalva.id}`
      );

      // Ordenar estabelecimentos alfabeticamente pela descrição
      this.estabelecimentos = this.ordenarEstabelecimentosPorDescricao(
        res.data || []
      );
      this.estabelecimentosExibidos = [...this.estabelecimentos];
    } catch (error) {
      console.error('Erro ao carregar estabelecimentos:', error);
      this.snackbarService.error('Erro ao carregar estabelecimentos');
    } finally {
      this.carregando = false;
    }
  }

  // Método para ordenar estabelecimentos por descrição (ordem alfabética)
  private ordenarEstabelecimentosPorDescricao(estabelecimentos: any[]): any[] {
    return estabelecimentos.sort((a, b) => {
      const descricaoA = (a.descricao || '').toLowerCase();
      const descricaoB = (b.descricao || '').toLowerCase();

      if (descricaoA < descricaoB) return -1;
      if (descricaoA > descricaoB) return 1;
      return 0;
    });
  }

  acessarEstabelecimento(estabelecimento: any): void {
    if (this.dadosCompartilhados?.onAcessarEstabelecimento) {
      this.dadosCompartilhados.onAcessarEstabelecimento(estabelecimento);
    }
  }

  async recarregarEstabelecimentos(): Promise<void> {
    await this.carregarEstabelecimentos();
  }

  aplicarFiltro(): void {
    const filtro = this.filtroNome.toLowerCase().trim();

    if (!filtro) {
      this.estabelecimentosExibidos = [...this.estabelecimentos];
      return;
    }

    this.estabelecimentosExibidos = this.estabelecimentos.filter((e) => {
      const nome = (e.descricao || '').toLowerCase();
      const endereco = (this.getResumoEndereco(e) || '').toLowerCase();
      return nome.includes(filtro) || endereco.includes(filtro);
    });

    // Manter a ordenação mesmo após filtrar
    this.estabelecimentosExibidos = this.ordenarEstabelecimentosPorDescricao(
      this.estabelecimentosExibidos
    );
  }

  getResumoEndereco(estabelecimento: any): string {
    if (!estabelecimento?.enderecos?.length) return 'Endereço não disponível';

    const endereco = estabelecimento.enderecos[0];

    return `${endereco.logradouro}, ${endereco.numero || 'S/N'} - ${
      endereco.cidade
    }/${endereco.estado}, ${formatarCEP(endereco.cep)}`;
  }

  adicionarEstabelecimento(): void {
    if (this.dadosCompartilhados?.onAdicionarEstabelecimento) {
      this.dadosCompartilhados.onAdicionarEstabelecimento();
    }
  }

  voltarParaDadosGerais(): void {
    if (this.dadosCompartilhados?.changeActiveScreen) {
      this.dadosCompartilhados.changeActiveScreen(
        this.dadosCompartilhados.CADASTRAR_DADOS_GERAIS
      );
    }
  }
}
